import React from 'react';

// Timer warning overlay - shows when time is running low
const TimerWarning = ({ warningLevel, remainingTime }) => {
  if (!warningLevel) return null;

  const warningText = {
    critical: 'TIME IS ALMOST UP!',
    urgent: 'Hurry! Time is running out!',
    warning: 'Time is running low...',
  };

  return (
    <div className={`timer-warning-overlay timer-warning-${warningLevel}`}>
      <div className="timer-warning-content">
        <span className="timer-warning-icon">⏰</span>
        <span className="timer-warning-text">{warningText[warningLevel]}</span>
        <span className="timer-warning-time">{remainingTime}s</span>
      </div>
    </div>
  );
};

export default TimerWarning;
